import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Use useNavigate for navigation
import apiHelper from '../../utils/apiHelpers';
import formatter from '../../utils/formatter';
import CustomTooltip from '../common/Tooltip';
import Loader from '../common/Loader';
import Button from '../common/Button';
import Alert from '../common/Alert';
import Input from '../common/Input';

const Profile = () => {
  const [user, setUser] = useState({
    username: '',
    email: '',
    password: '',
    moxfieldWishlist: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    apiHelper
      .getCurrentUser()
      .then(response => {
        setUser(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const handleChange = event => {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    value =
      target.type === 'react-datetime'
        ? formatter.formatDateForAPI(target.value)
        : target.value;
    const name = target.name;
    const newUser = { ...user, [name]: value }; // Simpler spread syntax
    setUser(newUser);
  };

  const submitUser = async () => {
    try {
      setLoading(true);
      await apiHelper.updateMoxfieldURL(user.moxfieldWishlist);
      setLoading(false);
      navigate('/wishlist'); // Use navigate for routing
    } catch (error) {
      setLoading(false);
      let errorMessage;
      if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 422) {
          errorMessage = 'Datos invalidos o incompletos';
        } else {
          errorMessage =
            error.response.data?.error?.message || error.response.data;
        }
      } else {
        errorMessage = 'Error de conexión con el servidor';
      }
      setErrorMessage(errorMessage);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="flex flex-col gap-y-2">
        <div className="flex flex-row items-center">
          <label htmlFor="username" className="text-white">
            Usuario
          </label>
          <span
            data-tip
            data-tooltip-id="Tooltip-username"
            className="ml-1 fa fa-info-circle text-white"></span>
          <CustomTooltip
            id="Tooltip-username"
            tooltipText="Nombre de usuario. Junto con la contraseña, se utilizará para iniciar sesión."
          />
        </div>
        <Input
          type="text"
          name="username"
          placeholder="Usuario"
          value={user.username}
          disabled={true}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="flex flex-row items-center">
          <label htmlFor="password" className="text-white">
            Contraseña
          </label>
          <span
            data-tip
            data-tooltip-id="Tooltip-password"
            className="ml-1 fa fa-info-circle text-white"></span>
          <CustomTooltip
            id="Tooltip-password"
            tooltipText="Contraseña del usuario. Junto con el nombre de usuario, se utilizará para iniciar sesión."
          />
        </div>
        <Input
          type="text"
          name="password"
          placeholder="Contraseña"
          value={user.password}
          disabled={true}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="flex flex-row items-center">
          <label htmlFor="email" className="text-white">
            Email
          </label>
          <span
            data-tip
            data-tooltip-id="Tooltip-email"
            className="ml-1 fa fa-info-circle text-white"></span>
          <CustomTooltip
            id="Tooltip-email"
            tooltipText="Email del usuario. Se utilizará para recibir las notificaciones del sistema."
          />
        </div>
        <Input
          type="text"
          name="email"
          placeholder="Email"
          value={user.email}
          disabled={true}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="flex flex-row items-center">
          <label htmlFor="moxfieldWishlist" className="text-white">
            URL de wishlist de Moxfield
          </label>
          <span
            data-tip
            data-tooltip-id="Tooltip-moxfieldWishlist"
            className="ml-1 fa fa-info-circle text-white"></span>
          <CustomTooltip
            id="Tooltip-moxfieldWishlist"
            tooltipText="Wishlist de Moxfield del usuario. Se utilizará para actualizar la Wishlist."
          />
        </div>
        <Input
          type="text"
          name="moxfieldWishlist"
          placeholder="URL de wishlist de Moxfield"
          value={user.moxfieldWishlist}
          onChange={handleChange}
        />
      </div>
      <Alert>{errorMessage}</Alert>
      <div>
        <Button className="w-full" iconClass="fas fa-save" onClick={submitUser}>
          Guardar
        </Button>
      </div>
    </div>
  );
};

export default Profile;
